/** 軌道の SVG 描画（カード用スパークラインと詳細用チャート） */
export const JOINT_COLORS =
  ['#4cc9f0', '#f72585', '#ffd166', '#06d6a0', '#b892ff', '#ff8c42',
   '#7dd3fc', '#fb7185', '#a3e635', '#e879f9', '#facc15', '#34d399'];

/**
 * 関節ぶんの色。手持ちのパレットに収まらない本数（OpenArm 双腕の 16、
 * pos/vel/torque を持つ 24 など）では、剰余で使い回すと別の関節が同じ色になる。
 * そこで黄金角で色相を配り、どこを切り取っても隣同士が近い色にならないようにする。
 */
export function colorsFor(n){
  if(n <= JOINT_COLORS.length) return JOINT_COLORS.slice(0, n);
  return Array.from({ length: n }, (_, i) =>
    `hsl(${(i * 137.508 % 360).toFixed(1)} 78% ${i % 2 ? 61 : 72}%)`);
}

/** show（描く関節の番号）が無ければ全部描く */
const visible = (show, j) => !show || show.has(j);

function points(series, range, W, H, pad, maxPts){
  const n = series.length;
  const step = Math.max(1, Math.floor(n / maxPts));
  const [lo, hi] = range, span = (hi - lo) || 1;
  const out = [];
  for(let k = 0; k < n; k += step)
    out.push(`${(k / (n - 1) * W).toFixed(1)},${(H - pad - ((series[k] - lo) / span) * (H - 2 * pad)).toFixed(1)}`);
  return out.join(' ');
}

/** カード下部の小さな軌道（state のみ） */
export function sparkline(traj, ranges, { show = null, colors = JOINT_COLORS, W = 600, H = 64 } = {}){
  let s = '';
  traj.state.forEach((series, j) => {
    if(!visible(show, j)) return;
    s += `<polyline points="${points(series, ranges[j], W, H, 5, 90)}" fill="none" stroke="${colors[j]}" stroke-width="1.2" opacity=".85"/>`;
  });
  return s + `<line class="ph" x1="0" x2="0" y1="0" y2="${H}" stroke="#fff" stroke-width="1" opacity=".7"/>`;
}

/** 詳細ダイアログ用（state 実線 / action 破線） */
export function chart(traj, ranges, { hidden = new Set(), show = null, colors = JOINT_COLORS, W = 1000, H = 240 } = {}){
  let s = '';
  for(let g = 1; g < 4; g++)
    s += `<line x1="0" x2="${W}" y1="${g * H / 4}" y2="${g * H / 4}" stroke="#2a3441"/>`;
  traj.state.forEach((_, j) => {
    if(hidden.has(j) || !visible(show, j)) return;
    s += `<polyline points="${points(traj.action[j], ranges[j], W, H, 8, 600)}" fill="none" stroke="${colors[j]}" stroke-width="1.2" stroke-dasharray="4 3" opacity=".55"/>`;
    s += `<polyline points="${points(traj.state[j], ranges[j], W, H, 8, 600)}" fill="none" stroke="${colors[j]}" stroke-width="1.8" opacity=".95"/>`;
  });
  return s + `<line class="ph" x1="0" x2="0" y1="0" y2="${H}" stroke="#fff" stroke-width="1.5" opacity=".8"/>`;
}

/** range が未算出のデータセット向けに、読み込み済み軌道からレンジを作る */
export function rangeOf(traj){
  return traj.state.map((series, j) => {
    let lo = Infinity, hi = -Infinity;
    for(const v of series){ if(v < lo) lo = v; if(v > hi) hi = v; }
    for(const v of traj.action[j]){ if(v < lo) lo = v; if(v > hi) hi = v; }
    return [lo, hi];
  });
}
